// AJAX pagination for Tag show association panels.
//
// ActiveAdmin has Turbo disabled in this app, so we fetch the next page HTML and
// replace only the association panel container in-place.

async function fetchHtml(url) {
  const resp = await fetch(url, {
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Accept": "text/html"
    },
    credentials: "same-origin"
  });
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  return await resp.text();
}

function containerForLink(link) {
  return link.closest(".aa-tag-assoc-container");
}

function parseDocument(html) {
  const parser = new DOMParser();
  return parser.parseFromString(html, "text/html");
}

function updateUrl(url) {
  try {
    window.history.pushState({}, "", url);
  } catch {
    // ignore
  }
}

function isPaginationLink(link) {
  return link instanceof HTMLAnchorElement &&
    link.closest(".aa-tag-associations-pagination") &&
    link.getAttribute("href");
}

function install() {
  document.addEventListener("click", async (event) => {
    const link = event.target instanceof Element ? event.target.closest("a") : null;
    if (!link || !isPaginationLink(link)) return;

    const container = containerForLink(link);
    if (!container) return;

    const href = link.getAttribute("href");
    if (!href || href.startsWith("#")) return;

    event.preventDefault();
    event.stopPropagation();

    container.setAttribute("aria-busy", "true");

    try {
      const html = await fetchHtml(href);
      const doc = parseDocument(html);
      const id = container.id;
      const nextContainer = id ? doc.getElementById(id) : null;
      if (!nextContainer) return;

      container.replaceWith(nextContainer);
      updateUrl(href);
    } catch {
      // fallback: do full navigation if anything goes wrong
      window.location.href = href;
    } finally {
      // if replaced, the old container is gone; if not replaced, clear busy
      const current = document.getElementById(container.id);
      if (current) current.removeAttribute("aria-busy");
    }
  }, true);
}

document.addEventListener("DOMContentLoaded", install);

export default {};

